import React from 'react'
import { PortfolioTrackEventType, PortfolioTrackingEvent } from '../../models/Portfolio';
import { Box, Button, Divider, ITheme, Typography, useTheme } from '@mui/material';
import { Utilities } from '../../utility/utils';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../resources/routes-constants';

export interface ITrackStepListItemProps {
    name: string;
    size: number;
    step: PortfolioTrackingEvent;
    isActiveStep: boolean;
}

const TrackStepListItem: React.FC<ITrackStepListItemProps> = ({ name, size, step, isActiveStep }) => {
    const theme = useTheme() as ITheme;
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();

    const onGoToSummary = () => {
        navigate(AUTHENTICATED_ROUTES.PORTFOLIO_SUMMARY_ROUTE.replace(":id", id as string))
    }

    const onGoToApiKey = () => {
        navigate(AUTHENTICATED_ROUTES.SETTING_ROUTE)
    }
    
    const onGoToDocuments = () => {
        navigate(AUTHENTICATED_ROUTES.PORTFOLIO_EDIT_STEP_ROUTE.replace(":step", "7").replace(":id", id as string))
    }

    const getTitle = (): string => {
        switch (step.type) {
            case PortfolioTrackEventType.Submit:
                return t('TrackingPortfolioEvent1');
            case PortfolioTrackEventType.Lawyers:
                return t('TrackingPortfolioEvent2');
            case PortfolioTrackEventType.MissingDocument:
                return t('TrackingPortfolioEvent3');
            case PortfolioTrackEventType.Completed:
                return t('TrackingPortfolioEvent4');
        }
    }

    const getButton = (): React.ReactNode => {
        switch (step.type) {
            case PortfolioTrackEventType.Submit:
                return <Button variant='outlined' onClick={onGoToSummary}>{t('TrackingPortfolioCheckPortfolioDetails')}</Button>
            case PortfolioTrackEventType.Completed:
                return <Button variant='contained' onClick={onGoToApiKey}>{t('TrackingPortfolioGetApiKey')}</Button>
            case PortfolioTrackEventType.Lawyers:
                return <></>
            case PortfolioTrackEventType.MissingDocument:
                return <Button variant='outlined' disabled={!isActiveStep} onClick={onGoToDocuments}>{t('TrackingPortfolioUploadDocuments')}</Button>
        }
    }

    return <Box display={"flex"} flexDirection={"column"} justifyContent={"space-around"} width={"240px"} flexBasis={"240px"} borderRadius={"16px"} boxShadow={"0px 2px 16px 0px #0000000F"} padding={"25px 16px"} bgcolor={theme.palette.background.paper} gap={"12px"}>
        <Typography fontSize={"18px"} fontWeight={"700"} lineHeight={"21.94px"} color={theme.palette.primary.dark}>{getTitle()}</Typography>
        <Divider />
        <Typography fontSize={"21px"} fontWeight={"700"} lineHeight={"25.6px"}>{name}</Typography>
        <Box display={"flex"} flexDirection={"column"}>
            <Typography fontSize={"22px"} fontWeight={"700"} lineHeight={"26.82px"} color={theme.palette.primary.main}>€{Utilities.toFriendlyMoneyValue(size)}</Typography>
            <Typography fontSize={"12px"} fontWeight={"500"} lineHeight={"14.63px"} color={theme.palette.primary.main}>{t('PortfolioPageItemFundraisingTarget')}</Typography>
        </Box>
        <Typography>{t('TrackingPortfolioDate')} {step.eventTime.toLocaleDateString(i18n.language, { dateStyle: 'short' })}</Typography>
        <Typography>{t('TrackingPortfolioTime')} {step.eventTime.toLocaleTimeString(i18n.language, { timeStyle: 'short' })}</Typography>
        {getButton()}
    </Box>
}

export default TrackStepListItem